import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  DoughnutController,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';

let registered = false;

/**
 * Registers the controllers, elements and scales the kit's charts actually draw with,
 * once per process. `registerables` would pull in every chart type chart.js ships —
 * radar, polar area, bubble, scatter and their scales — none of which anything here
 * renders.
 */
export function registerCharts() {
  if (registered) {
    return;
  }

  Chart.register(
    ArcElement,
    BarController,
    BarElement,
    CategoryScale,
    DoughnutController,
    Legend,
    LineController,
    LineElement,
    LinearScale,
    PointElement,
    Title,
    Tooltip,
  );

  registered = true;
}
